import QuickOptionEntry from './QuickOptionEntry';
import QuickOptionSearchEntry from './QuickOptionSearchEntry';
import mountAndShowFullOptions from '../../utils/mountAndShowFullOptions';
import { setSearchTerm, getSearchResults, getQuery } from 'owa-options-search';
import { getQuickOptions } from 'owa-options-store';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { resetSearch } from 'owa-options-search';

const styles = require('./QuickOptions.scss');
const classNames = require('classnames/bind').bind(styles);

export interface QuickOptionsProps {
    onDismiss?: () => void;
}

@observer
export default class QuickOptions extends React.Component<QuickOptionsProps> {
    render() {
        let isSearch = !!getQuery();
        let searchResults = getSearchResults();

        return (
            <div className={styles.container}>
                <SearchBox
                    title={strings.optionsFlex_searchPlaceholder}
                    labelText={strings.optionsFlex_searchPlaceholder}
                    value={getQuery()}
                    onChange={setSearchTerm}
                    className={styles.searchBox}
                />
                <div className={styles.settingsScrollContainer}>
                    <div className={styles.quickSettingsPanel}>
                        {isSearch
                            ? searchResults.map((option, index) => (
                                  <QuickOptionSearchEntry
                                      onDismiss={this.props.onDismiss}
                                      option={option}
                                      key={option.key}
                                  />
                              ))
                            : getQuickOptions().map((quickOption, index) => (
                                  <QuickOptionEntry
                                      onDismiss={this.props.onDismiss}
                                      key={quickOption.key}
                                      optionKey={quickOption.key}
                                      quickOptionSetting={quickOption.quickOptionSettings}
                                      titleStringKey={quickOption.titleStringKey}
                                  />
                              ))}
                        {isSearch && searchResults.length == 0 && (
                            <div className={styles.quickSetting}>
                                <span
                                    className={classNames(
                                        styles.quickSettingHeader,
                                        styles.noResults
                                    )}>
                                    {strings.optionsFull_search_noResults}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.footerButtons}>
                    <CommandButton
                        className={styles.viewFullSettings}
                        onClick={this.goToFullOptions}>
                        <span>{strings.optionsFlex_goToFullOptions}</span>
                        <Icon
                            iconName={
                                getRTL() ? ControlIcons.MiniExpand : ControlIcons.MiniExpandMirrored
                            }
                            className={classNames(styles.icon, 'flipForRtl')}
                        />
                    </CommandButton>
                </div>
            </div>
        );
    }

    componentWillUnmount() {
        this.onDismiss();
    }

    private onDismiss = () => {
        if (this.props.onDismiss) {
            resetSearch(false /*successfulSearch*/);
            this.props.onDismiss();
        }
    };

    private goToFullOptions = () => {
        mountAndShowFullOptions();
        this.onDismiss();
    };
}
